export default {"src":"/_next/static/media/soc-cybersecurity.7646488c.svg","height":188,"width":303,"blurWidth":0,"blurHeight":0};